import React, { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import "../../styles/Header.css";
import { useParams } from "react-router-dom";
import "../../styles/ThemeHeader.css";

const ThemeHeader = () => {
  const { clientid } = useParams();
  const [activeTab, setActiveTab] = useState("color");

  const apps = ["color", "typography", "layout", "aesthetics", "forms", "assets"];

  const renderedLinks = apps.map((app) => {
    return (
      <Link
        to={`/themeeditor/${clientid}/${app}`}
        className={`theme-header-link-item ${activeTab === app ? "active" : ""}`}
        onClick={() => setActiveTab(app)}
        key={app}>
        {app}
      </Link>
    );
  });

  return (
    <div className="theme-editor">
      <nav className="theme-header-links">{renderedLinks}</nav>
      <Outlet />
    </div>
  );
};

export default ThemeHeader;
